export default __webpack_public_path__ + "static/media/profile.15422c43.svg";